var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    { staticClass: "spacer-top-big", attrs: { "offset-lg": "3", lg: "6" } },
    [
      _c(
        "b-form",
        [
          _c(
            "b-card",
            {
              staticClass: "card-small",
              attrs: { "header-tag": "h3", header: "Item Detail" }
            },
            [
              _c(
                "b-row",
                { staticClass: "pb-3" },
                [
                  _c("b-col", { attrs: { lg: "3" } }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("TestItems.title")) + ":")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { lg: "9" } }, [
                    _vm._v(_vm._s(_vm.Item.title))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { lg: "3" } }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("TestItems.description")) + ":")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { lg: "9" } }, [
                    _vm._v(_vm._s(_vm.Item.description))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "text-right",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _vm.Item.id
                    ? _c(
                        "b-btn",
                        {
                          attrs: {
                            "data-trackname": "itemDetailDelete",
                            variant: "danger"
                          },
                          on: { click: _vm.delete_item }
                        },
                        [
                          _vm._v(
                            "\n             " +
                              _vm._s(_vm.$t("TestItems.delete")) +
                              "\n             "
                          ),
                          _c("i", { staticClass: "fa fa-trash" })
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Index/ItemDetail.vue?vue&type=template&id=7512cc08&
// module id = null
// module chunks = 